export const getNoodlingByIdTypes = {
  REQUEST: 'NOODLING_GET_BY_ID_REQUEST',
  SUCCESS: 'NOODLING_GET_BY_ID_SUCCESS',
  FAILED: 'NOODLING_GET_BY_ID_FAILED',
};
